<template>
<add-edit-user></add-edit-user>
</template>
<script>
import AddEditUser from "@/layouts/components/users/addedit-user.vue"
export default {
 components : {
   AddEditUser
 },
};
</script>     